<template>
  <q-section v-bind="$attrs" w="375">
    <q-section v-for="(rule, index) in rules" v-show="active === index" :key="`rule-${index}`" :bg-i="rule" p="relative">
      <ui-back :bg-i="$attrs.back || 'icon-back'" pl="16" />
      <ui-footer fs="12" fw="400" :fc="footerFc" class="ws-nowrap" pc="x" pb="20" />
      <q-section :wh="$attrs.tabWh || '264 57'" pc="x" :pt="$attrs.tabPt || 82" class="flex justify-between">
        <q-section
          v-for="(rule, index) in rules"
          :key="`rule-${index}`"
          :w="`${100 / rules.length}%`"
          h="100%"
          p="relative"
          @click="active = index"></q-section>
      </q-section>
    </q-section>
  </q-section>
</template>

<script setup lang="ts">
import { ref, useAttrs, onMounted } from 'vue'
import { useRoute } from 'vue-router'
const route = useRoute()

const $attrs = useAttrs()

defineProps({
  rules: {
    type: Array<string>,
    required: true,
  },
  footerFc: {
    type: String,
    default: 'rgba(0, 0, 0, 0.40)',
  },
})

const active = ref(0)
onMounted(() => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })

  if (route.query.target) {
    active.value = Number(route.query.target)
  }
})
</script>

<style scoped lang="scss"></style>
